export default "__VITE_ASSET__7342142e__"